// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ``, "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"black": `#000`,
	"white": `#fff`,
	"primary_20": `#003f35`,
	"primary_30": `#004d40`,
	"primary_35": `#00594a`,
	"primary_40": `#006a59`,
	"primary_45": `#5a9e67`,
	"primary_50": `#4d978b`,
	"primary_60": `#8cbcb4`,
	"primary_70": `#b2d2cd`,
	"primary_80": `#cce1de`,
	"primary_90": `#e5f0ee`,
	"secondary_40": `#3b71f7`,
	"secondary_80": `#e6f8f5`,
	"gradient_20": `linear-gradient(90deg, #f9e0a2 0%, #efb217 100%)`,
	"gradient_40": `linear-gradient(90deg, #006a59 0%, #00ff59 100%)`,
	"gradient_60": `linear-gradient(90deg, #b3e5c9 0%, #c2f0d3 100%)`,
	"gradient_80": `linear-gradient(180deg, #e5f0ee 0%, #e5f0ee 100%)`,
	"error_20": `#410001`,
	"error_30": `#7d0008`,
	"error_40": `#bf3c32`,
	"error_45": `#e24d39`,
	"error_50": `#ff8a7c`,
	"error_60": `#df847d`,
	"error_80": `#ffdad5`,
	"neutral_10": `#26282d`,
	"neutral_20": `#46474a`,
	"neutral_30": `#76777a`,
	"neutral_40": `#aeafb1`,
	"neutral_60": `#dbdcdf`,
	"neutral_80": `#eef0f5`,
	"neutral_90": `#fafafa`,
	"warning_40": `#f9e0a2`,
	"warning_50": `#f5d174`,
	"warning_60": `#efb217`,
	"warning_80": `#ffefc8`,
	"warning_90": `#fff8e5`,
	"red_80": `#fcedeb`,
	"green_30": `#006b5d`,
	"green_50": `#006a59`,
	"green_70": `#80d9cd`,
	"green_80": `#cce1de`,
	"green_90": `#ccf0eb`,
	"accent_40": `#ff6a59`,
	"highlight_40": `aqua`,
	"highlight_50": `#ffe101`,
	"yellow_20": `#d08d00`,
	"yellow_30": `#e19900`,
	"yellow_40": `#efb217`,
	"yellow_50": `#f5d174`,
	"yellow_60": `#f9e0a2`
};
export default ___CSS_LOADER_EXPORT___;
